import gql from 'graphql-tag';

const hostContactDetailFragments = {
    HostContactDetail: gql`
        fragment HostContactDetailHostContactDetail on HostContactDetail {
            fullName
        }
    `,
};

export default hostContactDetailFragments;
